import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AimoCategory, AimoCategoryHierarchy} from '../../model/product.model';

import {AimoCategoryAdapter} from './aimo-category.adapter';
import {shareReplay} from "rxjs/operators";
import {EventService, LoginEvent} from "@spartacus/core";

@Injectable({
    providedIn: 'root',
})
export class AimoCategoryConnector {
    categoryCache = {};
    hierarchyCache = {};

    constructor(
        protected adapter: AimoCategoryAdapter,
        protected eventService: EventService
    ) {
        this.eventService
            .get(LoginEvent)
            .subscribe(() => {
                this.hierarchyCache = {};
                this.categoryCache = {};
            });
    }

    getCategoryById(userId: string, categoryId: string): Observable<AimoCategory> {
        if (this.categoryCache[categoryId]) {
            return this.categoryCache[categoryId];
        }
        const ret = this.adapter.getCategoryById(userId, categoryId)
            .pipe(shareReplay(1));
        this.categoryCache[categoryId] = ret;
        return ret;
    }

    getCategoryPathById(userId: string, categoryId: string): Observable<string> {
        return this.adapter.getCategoryPathById(userId, categoryId);
    }

    getCategoryHierarchyById(userId: string, categoryId: string): Observable<AimoCategoryHierarchy> {
        if (this.hierarchyCache[categoryId]) {
            return this.hierarchyCache[categoryId];
        }
        const ret = this.adapter.getCategoryHierarchyById(userId, categoryId)
            .pipe(shareReplay(1));
        this.hierarchyCache[categoryId] = ret;
        return ret;
    }
}
